import { Discord, Github, Medium, Telegram, Twitter } from "../../assets/logos";

export const social = [
  {
    title: "Twitter",
    logo: Twitter,
    href: "https://twitter.com/SentinelDVPN",
  },
  {
    title: "Discord",
    logo: Discord,
    href: "https://discord.com/invite/mmAA8qF",
  },
  {
    title: "Github",
    logo: Github,
    href: "https://github.com/sentinel-official",
  },
  {
    title: "Telegram",
    logo: Telegram,
    href: "https://t.me/SentinelDVPN",
  },
  {
    title: "Medium",
    logo: Medium,
    href: "https://medium.com/sentinel",
  },
];
